import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import type { LinkProps } from '@sravni/react-design-system/lib/Typography';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { Tip } from '@sravni/react-icons';

import styles from './LightweightCardAction.module.scss';

function ActionButton({ children = 'Получить', className, href, onClick, ...props }: LinkProps) {
  return (
    <Link
      href={href}
      onClick={href ? null : onClick}
      className={classNames(styles.button, className)}
      rel="nofollow"
      {...props}
    >
      {children}
    </Link>
  );
}

function TipModal({ onClick, className, icon = <Tip />, ...props }: ButtonProps & { icon?: ReactNode }) {
  return (
    <Button variant="secondary" onClick={onClick} className={classNames(styles.detailsButton, className)} {...props}>
      <Icon icon={icon} />
    </Button>
  );
}

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

function Container({ children, className, ...props }: ContainerProps) {
  return (
    <div className={classNames(styles.actions, className)} {...props}>
      {children}
    </div>
  );
}

export const LightweightCardAction = {
  Container,
  ActionButton,
  TipModal,
};
